import { get, capitalize, isEmpty, isArray, isObject } from 'lodash';
import { notification } from 'antd';

export default {
  setSelectValue(data = null, valKey = "alias", valLabel = "name") {
    if (data) {
      if (data.length === 0) return [];

      if (data[valKey] === undefined) {
        return {
          key: get(data, "key", data),
          label: get(data, "label", data)
        };
      } else {
        return {
          key: data[valKey],
          label: data[valLabel]
        };
      }
    } else {
      return undefined;
    }
  },
  getAllMessage(obj) {
    let str = null;
    if (!isEmpty(obj)) {
      if (isArray(obj)) {
        str = [];
        for (let i = 0; i < obj.length; i++) str.push(this.getAllMessage(obj[i]));
        str = str.join('\n');
      } else if (isObject(obj)) {
        str = [];
        for (let key in obj) str.push(`${key}: \n${this.getAllMessage(obj[key])}`);
        str = str.join('\n');
      } else {
        str = obj;
      }
      return str;
    } else {
      return '';
    }
  },
  setSelectValueMultiple(data = null, valKey = "alias", valLabel = "name") {
    const dataMultiple = []
    if (data) {
      for (let i in data) {
        dataMultiple.push(this.setSelectValue(data[i], valKey, valLabel))
      }
    }
    return dataMultiple
  },
  responseMessage(type = 'error', message, title = null, options = {}) {
    options = {
      stringOnly: true,
      ...options,
    };

    notification[type]({
      message: !title ? (type === 'error' ? 'Failed!' : capitalize(type) + '!') : title,
      description: options.stringOnly ? this.getAllMessage(message) : message,
      key: 'responseNotification',
      ...options,
    });
  }
}


// WEBPACK FOOTER //
// ./src/Lib/Utils.js